module.exports = __webpack_public_path__ + "static/media/tl.82df190d.svg";